import type { TileStatusVariant } from './Tile';
import styles from './tile.module.scss';

export type TileStatusProps = {
  /** Status label text */
  status: string;
  /** Color variant for the status badge */
  variant?: TileStatusVariant;
  /** Additional class name */
  className?: string;
};

const STATUS_VARIANTS: Record<string, TileStatusVariant> = {
  Available: 'green',
  'Live to public': 'green',
  Rehomed: 'grey',
  Reserved: 'grey',
  Ready: 'green',
  'Ready for rehoming': 'green',
  'Puppies available': 'green',
  'Waitlist open': 'blue',
  'Coming soon': 'blue',
  Listed: 'green',
  Unlisted: 'grey',
  Draft: 'grey',
  Active: 'green',
  Paused: 'red',
  'Global waitlist': 'blue'
};

/**
 * Get the variant for a status label if not explicitly provided
 */
export const getStatusVariant = (
  status: string | null | undefined
): TileStatusVariant => {
  if (!status) return 'grey';
  return STATUS_VARIANTS[status] || 'grey';
};

/**
 * TileStatus - Status badge for the tile
 */
export function TileStatus({ status, variant, className }: TileStatusProps) {
  const resolvedVariant = variant ?? getStatusVariant(status);
  const variantClass =
    styles[
      `tileStatus${resolvedVariant.charAt(0).toUpperCase()}${resolvedVariant.slice(1)}`
    ];

  return (
    <div className={`${styles.tileStatusContainer} ${className || ''}`}>
      <span className={`${styles.tileStatus} ${variantClass}`}>{status}</span>
    </div>
  );
}
